<template>
  <div
    class="modal fade order-placed"
    data-backdrop="static"
    data-keyboard="false"
    id="businessClosed"
    tabindex="-1"
    aria-labelledby="businessClosedLabel"
    aria-hidden="true"
    ref="businessClosedModal"
    style="z-index: 9999"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content business-modal-contnt">
        <div class="modal-body text-center">
          <p class="business-txt">
            {{
              $auth.setting &&
              ($auth.setting.not_available_reason == ""
                ? "not_available_reason"
                : $auth.setting.not_available_reason)
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
    };
  },
  mounted() {
    setTimeout(() => {
    if (this.$auth.setting) {
      let is_system_available = this.$auth.setting.is_system_available;
      if (is_system_available == "0" || is_system_available == "No") {
        window.$(this.$refs.businessClosedModal).modal();
      }
      var formatd = "HH:mm:ss";
      var timedateGet = moment().format("HH:mm:ss");
      var beforeTimeGet = moment(this.$auth.setting.system_start_time).format(
        "HH:mm:ss"
      );
      var afterTime = moment(this.$auth.setting.system_end_time).format(
        "HH:mm:ss"
      );
      let afterTimeGet = afterTime == "00:00:00" ? "23:59:00" : afterTime;
      var timed = moment(timedateGet, formatd),
        beforeTime = moment(beforeTimeGet, formatd),
        afterTime = moment(afterTimeGet, formatd);
      if (!timed.isBetween(beforeTime, afterTime)) {
        this.AlertData = {
          displayMessage:
            "We are daily serviceable between " +
            moment(beforeTime).format("hh:mm A") +
            " to " +
            moment(afterTime).format("hh:mm A") +
            " only. Please schedule your orders anytime in this slot only.", //this.$auth.setting.schedule_order_after_business_hours_text,
          isSetClass: "schedule-modal",
        };
        this.isAlert = true;
        window.$(this.$refs.AlertModal).modal();
      }
    }
    },2000)
  },
};
</script>